import React, { useEffect, useState } from 'react'
import { apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/pathObj'
import OButton from 'components/reusable/OButton'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import dayjs from 'dayjs'
import Table from './Table'
import Pagination from '../../Pagination'
import { useTranslation } from 'react-i18next'
import RequestView from './RequestView'
import helpers from 'utils/helpers'

const Request = () => {
  const { t } = useTranslation()
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const [requestList, setRequestList] = useState([])
  const [currentItem, setCurrentItem] = useState('')
  const [requestView, setRequestView] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [isInitialized, setIsInitialized] = useState(false)
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [departmentList, setDepartmentList] = useState("");
  const [filterData, setFilterData] = useState({
    searchKey: '',
    startDate: '',
    endDate: '',
    departmentType: "",
    isReset: false,
    isFilter: false
  })
  const [sort, setSort] = useState({
    sortBy: 'createdAt',
    sortType: 'desc'
  })

  const handleRequestView = item => {
    setCurrentItem(item)
    setRequestView(!requestView)
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const getDepartmentList = async () => {
    try {
      const res = await apiGet(apiPath.getDepartmentList, {});
      setDepartmentList(res?.data?.results);
    } catch (error) {
      console.log("error:", error);
    }
  };

  const allRequest = async data => {
    try {
      const { startDate, endDate, searchKey, isFilter, departmentType} = filterData
      if (
        (data?.deletePage && requestList?.length >= 1) ||
        (isFilter && data?.statusChange && requestList?.length >= 1)
      ) {
        setPage(page - 1)
        setPaginationObj({ ...paginationObj, page: page - 1 })
      }

      const payload = {
        page,
        pageSize,
        startDate: helpers?.ternaryCondition(
          startDate,
          dayjs(startDate).format('YYYY-MM-DD'),
          null
        ),
        endDate: helpers?.ternaryCondition(
          endDate,
          dayjs(endDate).format('YYYY-MM-DD'),
          null
        ),
        keyword: searchKey,
        sortBy: sort.sortBy,
        sortType: sort.sortType,
        departmentID: departmentType,
      }
      const path = apiPath.requestList
      const result = await apiGet(path, payload)
      const responseData = result?.data?.results
      const resultStatusData = result?.data?.success
      setRequestList(responseData?.docs)
      setPaginationObj({
        ...paginationObj,
        page: helpers?.ternaryCondition(
          resultStatusData,
          responseData.page,
          null
        ),
        pageCount: helpers?.ternaryCondition(
          resultStatusData,
          responseData.totalPages,
          null
        ),
        perPageItem: helpers?.ternaryCondition(
          resultStatusData,
          responseData?.docs.length,
          null
        ),
        totalItems: helpers?.ternaryCondition(
          resultStatusData,
          responseData.totalDocs,
          null
        )
      })
    } catch (error) {
      console.log('error in get all users list==>>>>', error.message)
    }
  }

  useEffect(() => {
    allRequest()
  }, [page, filterData, sort])

   useEffect(() => {
      getDepartmentList();
  }, []);

  const setDepartmentType = (e) => {
    setFilterData({
      ...filterData,
      departmentType: e.target.value,
      isFilter: true,
      isReset: false,
    });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      searchKey: '',
      startDate: '',
      endDate: '',
      departmentType: "",
      isReset: true,
      isFilter: false
    })
    setPage(1)
    setSearchTerm('')
  }

  const handleDateChange = (start, end) => {
    setPage(1)
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true
    })
  }

  useEffect(() => {
    helpers.setDebouncingFunction({
      isInitialized,
      setIsInitialized,
      debouncedSearchTerm,
      searchTerm,
      filterData,
      setFilterData,
      setPage
    })
  }, [debouncedSearchTerm])

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm)
    }, 500)
    return () => {
      clearTimeout(timeoutId)
    }
  }, [searchTerm])

  return (
    <>
      {' '}
      <div className='bg-[#F9F9F9]'>
        <div className='bg-white border border-[#E9EDF9] rounded-lg'>
          <form className='border-b border-b-[#E3E3E3] 2xl:flex gap-2 px-4 py-3 flex-wrap justify-between'>
            <div className='col-span-2 flex flex-wrap items-center mb-2 2xl:mb-0'>
              <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                <div className='relative flex items-center mb-3'>
                  <div className='absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none'>
                    {!searchTerm ? (
                      <svg
                        aria-hidden='true'
                        className='w-4 h-4 text-[#A5A5A5] dark:text-gray-40'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
                        />
                      </svg>
                    ) : (
                      ''
                    )}
                  </div>
                  <input
                    type='search'
                    id='default-search'
                    className='block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500'
                    placeholder='Employee name'
                    value={searchTerm}
                    title=''
                    required
                    onChange={e => setSearchTerm(e.target.value)}
                  />
                </div>
                <ODateRangePicker
                  handleDateChange={handleDateChange}
                  isReset={filterData?.isReset}
                  setIsReset={setFilterData}
                />
                <div className="flex items-center mb-3 ml-3">
                  <select
                    className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                    placeholder=" "
                    type="select"
                    id="departmentID"
                    value={filterData?.departmentType}
                    onChange={(e) => setDepartmentType(e)}
                  >
                    <option value="">{t("SELECT_DEPARTMENT_NAME")}</option>
                    {departmentList &&
                      departmentList.map((item) => {
                        return <option value={item?._id} key={item?._id}>{item?.name}</option>;
                      })}
                  </select>
                </div>
                <OButton
                  label='Reset'
                  type='button'
                  onClick={() => handleReset()}
                  extraClasses='ml-3 mb-3'
                  style={{ borderRadius: '0.5rem' }}
                />
              </div>
            </div>
            <div className='lg:pt-0 pt-2'>
              <label
                htmlFor='default-search'
                className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
              >
                {t('O_SEARCH')}
              </label>
            </div>
          </form>
          <Table
            requestList={requestList}
            page={page}
            allRequest={allRequest}
            handleRequestView={handleRequestView}
            currentItem={currentItem}
            requestView={requestView}
            setSort={setSort}
            sort={sort}
            setPage={setPage}
          />
          {paginationObj?.totalItems ? (
            <Pagination
              handlePageClick={handlePageClick}
              options={paginationObj}
              page={page}
            />
          ) : null}
        </div>

        {requestView && (
          <RequestView
            setRequestView={setRequestView}
            allRequest={allRequest}
            currentItem={currentItem}
            requestList={requestList}
          />
        )}
      </div>
    </>
  )
}

export default Request
